import { render } from "./ConstructorLayout.vue?vue&type=template&id=294df668"
import script from "./ConstructorLayout.vue?vue&type=script&lang=js"
export * from "./ConstructorLayout.vue?vue&type=script&lang=js"

import "./ConstructorLayout.vue?vue&type=style&index=0&id=294df668&lang=css"

import exportComponent from "/home/twig/Work/FRONT/adsquiz.front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__